import Spinner from '@berlitz/spinner'
import styled, { css } from 'styled-components'

import { InputProps, SwitchBoxProps } from './interface'

export const StyledSpinner = styled(Spinner)`
  border-left: 3px solid ${({ theme }) => theme.palette.blue100};
`

export const SpinnerBox = styled.div`
  position: absolute;
  width: max-content;
  padding: 6px;
`

export const Slider = styled.span<{ hasEvent?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.palette.blueGray50};
  transition: 0.4s;
  border-radius: 34px;

  ${({ hasEvent }) =>
    hasEvent &&
    css`
      cursor: pointer;
    `}

  &:before {
    position: absolute;
    content: '';
    height: 25px;
    width: 25px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`

export const Input = styled.input<InputProps>`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider} {
    background-color: ${({ theme }) => theme.palette.blue100};

    ${SpinnerBox} {
      transform: translateX(33px);
    }
  }

  &:focus + ${Slider} {
    box-shadow: 0 0 1px #2196f3;
  }

  &:checked + ${Slider}:before {
    transform: translateX(33px);

    ${({ size }) =>
      size &&
      size === 'sm' &&
      css`
        transform: translateX(25px);
      `}
  }
`

export const SwitchBox = styled.label<SwitchBoxProps>`
  position: relative;
  display: inline-block;
  width: 64px;
  height: 31px;

  ${({ loading, disabled, checked }) =>
    (loading || disabled) &&
    css`
      ${Slider} {
        background-color: rgba(0, 0, 0, 0.16);
      }

      ${Input} {
        &:checked + ${Slider} {
          ${checked &&
          css`
            background-color: rgba(0, 79, 239, 0.3);
          `}
        }
      }

      ${StyledSpinner} {
        ${checked
          ? css`
              border-top: 3px solid rgba(174, 198, 250, 0.2);
              border-right: 3px solid rgba(174, 198, 250, 0.2);
              border-bottom: 3px solid rgba(174, 198, 250, 0.2);
              border-left: 3px solid #aec6fa;
            `
          : css`
              border-top: 3px solid rgba(206, 208, 213, 0.2);
              border-right: 3px solid rgba(206, 208, 213, 0.2);
              border-bottom: 3px solid rgba(206, 208, 213, 0.2);
              border-left: 3px solid #ced0d5;
            `}
      }
    `}

  ${({ size, checked }) =>
    size &&
    size === 'sm' &&
    css`
      width: 44px;
      height: 21px;

      ${Slider} {
        &:before {
          height: 15px;
          width: 15px;
        }
      }

      ${Input} {
        &:checked + ${Slider} {
          ${SpinnerBox} {
            transform: translateX(23px);
          }
        }

        &:checked + ${Slider}:before {
          transform: translateX(23px);
        }
      }

      ${StyledSpinner} {
        height: 10px;
        width: 10px;

        ${checked
          ? css`
              border-top: 2px solid rgba(174, 198, 250, 0.2);
              border-right: 2px solid rgba(174, 198, 250, 0.2);
              border-bottom: 2px solid rgba(174, 198, 250, 0.2);
              border-left: 2px solid #aec6fa;
            `
          : css`
              border-top: 2px solid rgba(206, 208, 213, 0.2);
              border-right: 2px solid rgba(206, 208, 213, 0.2);
              border-bottom: 2px solid rgba(206, 208, 213, 0.2);
              border-left: 2px solid #ced0d5;
            `}
      }
    `}
`
